module.exports = __webpack_public_path__ + "static/img/transferencia.39f59b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/transferencia.png
// module id = wBma
// module chunks = 1